import { render, staticRenderFns } from "./service_limit.vue?vue&type=template&id=407c178a&scoped=true&lang=pug&"
import script from "./service_limit.vue?vue&type=script&lang=js&"
export * from "./service_limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407c178a",
  null
  
)

export default component.exports